export default __webpack_public_path__ + "static/media/bankholidaysunday2019.6a0b0d60.mp4";